import {
  parse,
  safeParse,
  getDefaults,
  pipe,
  object,
  transform,
  type InferInput as SchemaInferInput,
  type InferOutput as SchemaInferOutput,
  string,
  email,
  minLength,
  check,
  nonEmpty,
  enum_,
  picklist,
  array,
  optional,
  nullish,
  pick,
  boolean,
  number,
  base64,
} from 'valibot';

const Schema = {
  methods: {
    parse,
    safeParse,
    getDefaults,
    pick,
  },
  structures: {
    pipe,
    object,
    optional,
    transform,
    check,
    nullish,
  },
  schemas: {
    ID: () => pipe(string(), nonEmpty()),
    string,
    email,
    minLength,
    check,
    nonEmpty,
    enum: enum_,
    picklist,
    array,
    boolean,
    number,
    base64,

    dateFromString: () =>
      pipe(
        string(),
        transform((input: string) => new Date(input)),
        check((input: Date) => !Number.isNaN(input.getTime())),
      ),
  },
} as const;

export { Schema, type SchemaInferInput, type SchemaInferOutput };
